import React from "react";
import { connect } from "react-redux";
import { Button, Form, Input, Layout, Modal, Row, Space, Spin, Typography, message, notification } from 'antd';
import { useNavigate, useParams } from "react-router-dom";
import { getBiometricUserUrls, getByIdUser, getUserKycStatus, sendBiometricUrlEmail } from "services/user-service";
import { Header, SwitchLabel } from "components";
import { savePasswordUser, saveRefresh } from "services/user-service";
import { Footer } from "antd/es/layout/layout";
import { encryptRSA } from "utils";
import BiometricLinksModal from "./biometric-links-modal";
import Title from "antd/lib/typography/Title";

const { Content } = Layout;

const mapStateToProps = (state) => ({
    login: state.authReducer.loginReducer
});

const DataFetch = {
    user: {},
    loading: false
}

const UserPasswordScreen = (props) => {
    const { login } = props;
    const { id } = useParams();
    const [data, setData] = React.useState(DataFetch)
    const [loading, setLoading] = React.useState(false)
    const [sendShow, setSendShow] = React.useState(false)
    const [passwordShow, setPasswordShow] = React.useState(false)
    const [copyShow, setCopyShow] = React.useState(false)
    const [infosCopy, setInfosCopy] = React.useState({})
    const [formSend] = Form.useForm();
    const [formPassword] = Form.useForm();
    const navigate = useNavigate();
    const [openBiometricLinks, setOpenBiometricLinks] = React.useState(false);
    const [biometricUsers, setBiometricUsers] = React.useState([]);

    const load = async () => {
			try {
					setLoading(true);
					setData((x) => ({ ...x, loading: true }));
					const res = await getByIdUser(id)
                    const resKyc = await getUserKycStatus(id);
                    const user = { ...res.data, legalRepresentative: resKyc.legalRepresentative }
					setData({
							user: user
					});
					setLoading(false);
			} catch {
					setLoading(false);
			}
    }

    React.useEffect(() => {
        load();
    }, [])

    React.useEffect(() => {
        loadUserBiometricUrl();
    }, [data?.user])

    const loadUserBiometricUrl = () => {
        var users = [{...data?.user, relationshipType: 'Participante'}];
        if (data?.user && data?.user.legalRepresentative && data?.user.legalRepresentative?.biometricUrl && data?.user.legalRepresentative?.relationshipType !== 'emancipated_minor') {
            var legalRepresentative = { ...data?.user.legalRepresentative, cpf: formatCpf(data?.user.legalRepresentative.document) };
            users.push(legalRepresentative);
        }
        setBiometricUsers(users);
    }

    const formatCpf = (cpf) => {
        if (!cpf) return "";
        const digits = cpf.toString().replace(/\D/g, "");
        if (digits.length !== 11) {
            return cpf;
        }
        return digits.replace(
            /(\d{3})(\d{3})(\d{3})(\d{2})/,
            "$1.$2.$3-$4"
        );
    }

    const shouldShowBiometric = (status) => {
        return !["approved", "not_initiated"].includes(status?.toLowerCase());
    }

    const showBiometricButton = () => {
        const user = data?.user;

        return (
            shouldShowBiometric(user?.biometricStatus) ||
            shouldShowBiometric(user?.legalRepresentative?.biometricStatus)
        );
    };

    const needRefresh = (users = []) => {
        return users.some(user => user.biometricStatus.toLowerCase() === 'expired' || user.biometricStatus.toLowerCase() === 'rejected');
    }

    const openBiometricLinksModal = async () => {
        if(needRefresh(biometricUsers)) {
            setLoading(true);
            const links = await getBiometricUserUrls(id);
            setLoading(false);
            const usersWithUrls = biometricUsers.map((user) => ({
                ...user,
                biometricStatus: 'CREATED',
                biometricUrl:
                    user.relationshipType === "Participante"
                        ? links.url
                        : links.tutorUrl,
            }));
            setBiometricUsers(usersWithUrls);
        }
        setOpenBiometricLinks(true)
    }

    const sendBiometricLinks = async () => {
        Modal.confirm({
            title: "Enviar Link da biometria por E-mail",
            content:
                "Deseja enviar o link da biometria por E-mail?",
            okText: "Sim",
            cancelText: "Não",
            onOk: async () => {
                try {
                    await sendBiometricUrlEmail(id)
                    message.success("E-mail enviado com sucesso.");
                } catch (e) {
                    message.error("Erro ao enviar E-mail.");
                }
            },
        });
    }

    const formatPhone = (phone) => {
        phone = phone.slice(2)
        return phone.replace(/^(\d\d)(\d{5})(\d{4}).*/, "($1) $2-$3");
    }

    const onSaveRefresh = async () => {
        setLoading(true)
        try {
            await saveRefresh(id);
            notification.success({ message: "Usuário liberado com sucesso." });
            setLoading(false)
        } catch {
            setLoading(false)
        }
    }

    const saveSend = async (values) => {
        setLoading(true)
        try {
            await savePasswordUser(id, values.sendEmail, values.sendSms);
            notification.success({ message: "Envio de redefinição de senha efetuado com sucesso!" });
            setSendShow(false);
						formSend.resetFields();
						setLoading(false)
        } catch (e) {
					setLoading(false)
				}
    }

    const savePassword = async (values) => {
        setLoading(true)
        try {
						const { password, confirmation } = values
						const encryptedPassowrd = await encryptRSA(password);
						const encryptedConfirmation = await encryptRSA(confirmation);
            await savePasswordUser(id, false, false, encryptedPassowrd, encryptedConfirmation);
            notification.success({ message: "Senha salva com sucesso!" });
						formPassword.resetFields();
            setPasswordShow(false);
						setLoading(false)
        } catch {
					setLoading(false)
				}
    }

    const loadCopy = async () => {
        setLoading(true)
        try {
            let ret = await savePasswordUser(id, false, false, null, null, true);
            setInfosCopy(ret)
						setLoading(false)
        } catch (e) {
            setCopyShow(false)
						setLoading(false)
        }
    }

    const copyLink = async () => {
        setLoading(true)
        try {
            navigator.clipboard.writeText(infosCopy.link);
            notification.success({ message: `Link copiado para a área de transferência` });
						setLoading(false)
        } catch (e) {
            setCopyShow(false)
						setLoading(false)
        }
    }

    React.useEffect(() => {
        if (copyShow)
            loadCopy()
    }, [copyShow])

    return (
        <Layout className="alymente-layout">
            <Header title={`Senha \\ Biometria do Participante`} subtitle={data.user.name} />
            <Content style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: -100 }}>
                <Space direction="vertical" size="large">
                        <Space direction='vertical'>
                            <Title level={5} style={{ textAlign: "center" }}>Senha</Title>
                            <Button loading={loading} disabled={loading} block type="primary" onClick={() => setSendShow(true)}>Envio ao participante</Button>
                            {/* <Button loading={loading} disabled={loading} block type="primary" onClick={() => setPasswordShow(true)}>Cadastro de senha</Button> */}
                            <Button loading={loading} disabled={loading} block type="primary" onClick={() => setCopyShow(true)}>Cópia do link de envio</Button>
                            {(login.company.master || login.user.admin) &&
                                <Button loading={loading} disabled={loading} block type="primary" onClick={onSaveRefresh}>Liberar usuário por erro de tentativas</Button>
                            }
                            <Title level={5} style={{ textAlign: "center" }}>Biometria</Title>
                            <Button loading={loading} disabled={loading} block type="primary" onClick={openBiometricLinksModal}>Links</Button>
                            <Button loading={loading} disabled={loading} block type="primary" onClick={sendBiometricLinks}>Enviar biometria por E-mail</Button>
                        </Space>
                </Space>
            </Content>
            <Footer style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'left'
            }}>
                <Button
                    className="btn-save"
                    type="primary"
                    onClick={() => navigate(`/user/${id}`)}>
                    Voltar
                </Button>
            </Footer>
            <BiometricLinksModal
                open={openBiometricLinks}
                onClose={async () => {
                    setOpenBiometricLinks(false);
                    await load();
                }}
                users={biometricUsers}
            />
            <Modal
                open={sendShow}
                title="Envio ao participante"
                onCancel={() => setSendShow(false)}
                onOk={() => formSend.submit()}
								onCancel={() => {
									setSendShow(false);
									formSend.resetFields();
								}}
                confirmLoading={loading}
                width={600}
                okText={"Salvar"}
            >
                <Form form={formSend} layout="vertical" name="basic" onFinish={saveSend} align="center">
                    <Space direction="vertical" size="large" align="center">
                        <Spin spinning={loading}>
													{  data.user.email && data.user.email.length > 0 &&
														<Form.Item name={"sendEmail"} valuePropName="checked" >
															<SwitchLabel label="ENVIAR E-MAIL PARA REDEFINIÇÃO DE SENHA DO APLICATIVO" />
                            </Form.Item>
													}
													{ data.user.phone && data.user.phone.length > 0 &&
														<Form.Item name={"sendSms"} valuePropName="checked" >
															<SwitchLabel label="ENVIAR SMS PARA REDEFINIÇÃO DE SENHA DO APLICATIVO" />
														</Form.Item>
													}
                        </Spin>
                    </Space>
                </Form>
            </Modal>
            <Modal
                open={passwordShow}
                title="Cadastro de senha"
                onCancel={() => {
										formPassword.resetFields();
                    setInfosCopy({})
                    setPasswordShow(false);
                }}
                onOk={() => formPassword.submit()}
                confirmLoading={loading}
                width={600}
                okText={"Salvar"}
            >
                <Form form={formPassword} layout="vertical" name="basic" onFinish={savePassword} align="center">
                    <Space direction="vertical" size="large" align="center">
                        <Spin spinning={loading}>
                            <Form.Item
                                name={"password"}
                            >
                                <Input placeholder="Senha do Aplicativo" type={"password"} autoComplete="off" />
                            </Form.Item>
                            <Form.Item
                                name={"confirmation"}
                            >
                                <Input placeholder="Confirmação de Senha" type={"password"} autoComplete="off" />
                            </Form.Item>
                        </Spin>
                    </Space>
                </Form>
            </Modal>
            <Modal
                open={copyShow}
                title="Link de envio"
                onCancel={() => setCopyShow(false)}
                onOk={() => copyLink()}
                confirmLoading={loading}
                width={600}
                okText={"Copiar Link"}
            >
                <Space direction="vertical" size="large" align="center">
                    <Spin spinning={loading}>
                        <div>
                            <Row type="flex" justify="center">
                                <Typography.Text>Segue o link de redefinição de senha.</Typography.Text>
                            </Row>
                            <Row type="flex" justify="center">
                                <Typography.Text type="secondary" align="center">O link de redefinição de senha está associado exclusivamente ao participante.</Typography.Text>
                            </Row>
                            <Row type="flex" justify="center" align="center">
                                <div style={{ textAlign: "center", marginTop: 20 }}><a href={infosCopy.link} target="_blank" rel="noreferrer"> <Typography.Text align="center">{infosCopy.link}</Typography.Text> </a></div>
                            </Row>
                            <Row type="flex" justify="center" style={{ marginTop: 20 }}>
                                <Typography.Text type="secondary" align="center">O participante pode efetuar o login usando o email <Typography.Text>{infosCopy.email}</Typography.Text>{infosCopy.phone ? <Typography.Text type="secondary"> ou o telefone <Typography.Text>{formatPhone(infosCopy.phone)}</Typography.Text></Typography.Text> : ''}.</Typography.Text>
                            </Row>
                        </div>
                    </Spin>
                </Space>
            </Modal>
        </Layout>
    )
}

export default connect(mapStateToProps, {})(UserPasswordScreen);
